// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"34377d03","188":"b959ab07","196":"517fd6e6","364":"90306313","507":"bc92f412","719":"17c7ceda","795":"c78938cc","923":"5d9af952","962":"d88a697f"}[chunkId] + ".chunk.js";
};